module.exports = __webpack_public_path__ + "img/react.f7680b0d.png";